module.exports = __webpack_public_path__ + "img/d875993.png";